<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import { Trophy, LayoutTemplate, Map, ListRestart, Lock } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()

  import transitionPreview from "@images/free/transition-preview.jpg"
  let openModal = $state(true)
</script>

<div class="w-full">
  <img
    src={transitionPreview}
    class="w-full cursor-not-allowed"
    alt="Preview of a Standard Activity Page"
  />
</div>

<Modal
  closeButton={false}
  hasBackdrop={true}
  allowScroll={true}
  closeOnEsc={true}
  closeOnOuterClick={true}
  bind:open={openModal}
>
  <div class="py-4 px-6">
    <p
      class="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-3xl flex justify-start items-center"
    >
      <Lock class="size-7 text-red-800 mr-2" />
      Transition Meetings
    </p>
    <p class="mt-6 text-lg/8 text-gray-700">
      The Transition Meetings Feature is not available at your current Free
      Subscription level. Please upgrade to the Standard Subscription to access
      all the valuable features including the following:
    </p>
    <dl
      class="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none"
    >
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <Trophy class="size-6 absolute top-1 left-1 text-blue-600" />
          Top Recognitions
        </dt>
        <dd class="inline">
          Review your team members recognition stats for the given quarter or
          year. See and celebrate the top recognized team members and the top
          givers.
        </dd>
      </div>
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <LayoutTemplate class="size-6 absolute top-1 left-1 text-blue-600" />
          One Page Plan Review
        </dt>
        <dd class="inline">
          Review your team's One Page Plan and made any changes for the upcoming
          quarter.
        </dd>
      </div>
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <Map class="size-6 absolute top-1 left-1 text-blue-600" />
          Set Quarterly and Annual Visions
        </dt>
        <dd class="inline">
          Set a vision for the upocoming quarter and/or year. Help everyone on
          your team understand the mission and vision of the company and how
          they can contribute to it.
        </dd>
      </div>
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <ListRestart class="size-6 absolute top-1 left-1 text-blue-600" />

          Transition Goals and Tasks
        </dt>
        <dd class="inline">
          Close our your current quarter goals and tasks and set new ones for
          the coming quarter. Utilize our custom tools to help you set up your
          upcoming quarter for success.
        </dd>
      </div>
    </dl>
  </div>
  <div class="py-4 px-8 mt-6 flex justify-end border-t border-gray-200">
    <a
      href={`/plans/${appStore.plan.id}/admin`}
      class="rounded-md bg-green-600 px-3.5 py-2.5 text-base font-semibold text-white shadow-xs hover:bg-green-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
      >Upgrade Now</a
    >
  </div>
</Modal>
